import { render, staticRenderFns } from "./RouterViewBody.vue?vue&type=template&id=096177cc&"
import script from "./RouterViewBody.vue?vue&type=script&lang=js&"
export * from "./RouterViewBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports